<template>
  <div>
    <header class="header-main-top">
      <div
        class="header-main d-flex justify-content-between align-items-center"
      >
        <div class="d-flex">
          <div class="mx-3">
            <!-- <img src="../../assets/img/h3xlogo.svg" alt="" /> -->
            <img
              src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/hire3xlogo.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  name: "StaticHeader",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="" scoped></style>
